import type { SchemaViewerFieldProps } from "./schema-viewer-field.type";

import { isSchemaFieldNumber, isSchemaFieldText } from "@/entities/schema";

import { SchemaViewerFieldExpression } from "../schema-viewer-field-expression";
import { SchemaViewerFieldNumber } from "../schema-viewer-field-number";
import { SchemaViewerFieldText } from "../schema-viewer-field-text";

export const SchemaViewerField = ({
  schema,
  form,
  disabled,
  ...formItemProps
}: SchemaViewerFieldProps) => {
  const { type } = schema;
  const commonProps = { disabled, ...formItemProps };

  if (isSchemaFieldText(schema)) {
    return <SchemaViewerFieldText schema={schema} {...commonProps} />;
  }

  if (isSchemaFieldNumber(schema)) {
    return <SchemaViewerFieldNumber schema={schema} {...commonProps} />;
  }

  if (type === "expression") {
    return <SchemaViewerFieldExpression schema={schema} form={form} />;
  }

  return null;
};
